import axios from "axios";
import {store} from "../configureStore";


export function registerPushToken() {
    if(!store.getState().Auth.authToken||!store.getState().Auth.pushToken){
        return
    }
    const instance = axios.create({
        baseURL: process.env.REACT_APP_API_URL,
        timeout: 30000,
        headers: {
            Authorization: `Bearer  ${store.getState().Auth.authToken}`,
            'Content-Type': 'application/json',
        },
    });

    return instance.post(
        process.env.REACT_APP_API_URL + `user/users/${store.getState().Auth.user.id}/add_firebase_token_mobile/`,
        {token:store.getState().Auth.pushToken}
    )
}

export function deletePushToken() {
    if(!store.getState().Auth.authToken||!store.getState().Auth.pushToken){
        return
    }
    const instance = axios.create({
        baseURL: process.env.REACT_APP_API_URL,
        timeout: 30000,
        headers: {
            Authorization: `Bearer  ${store.getState().Auth.authToken}`,
            'Content-Type': 'application/json',
        },
    });

    return instance.post(
        process.env.REACT_APP_API_URL + `user/users/${store.getState().Auth.user.id}/delete_firebase_token_mobile/`,
        {token:store.getState().Auth.pushToken}
    )
}
